
import React from "react";
import SubMenu from "../../base/SubMenu";
import Start from "./Start";
import HHereBerufsfachschule from "./HöhereBerufsfachschule";
import Downloads from "../base/Downloads";
import Ubersicht from "./Übersicht";
function Main(props) {


    const startRef = React.createRef()
    const ubersichtRef = React.createRef()
    const horeBerRef = React.createRef()
    const teamRef = React.createRef()
    const downloadsRef= React.createRef()

    return (
        <React.Fragment>
            <SubMenu model={{
                background: "#4997D2",
                items: [
                    { label: <strong>Höhere Berufsfachschule</strong>},
                    { label: "Start", onClick: () => window.location.href = "/bildungsangebote/hoehereberufsfachschule"},
                    { label: "HBFS", onClick: () => startRef.current.scrollIntoView()},
                    { label: "Übersicht", onClick: () => ubersichtRef.current.scrollIntoView()},
                    { label: "Höhere Berufsfachschule", onClick: () => horeBerRef.current.scrollIntoView()},
                    { label: "Downloads", onClick:()=> downloadsRef.current.scrollIntoView()}
                ]
            }}/>
            <div ref={startRef} ><Start/></div>
            <div ref={ubersichtRef}><Ubersicht/></div>
            <div ref={horeBerRef}><HHereBerufsfachschule/></div>
            <div ref={downloadsRef} style={{color: "#488e62"}}>
                <Downloads
                    model={
                        {
                            items: [
                                {label: 'BFS Anmeldeformular', download: 'BFS Schulvertrag.pdf', url: '/assets/höhereberufsfachschule/Schulvertrag_BFS_mai25.pdf'},
                                {label: 'H-BFS Verordnung über die Ausbildung und die Prüfung vom 02. Dezember 2011', download: 'BFS Verordnung über die Ausbildung und die Prüfung.pdf', url: '/assets/höhereberufsfachschule/BFS Verordnung über die Ausbildung und die Prüfung.pdf'},
                                {label: 'BFS Vordruck Entschuldigungsschreiben',download: 'BFS Vordruck Entschuldigungsschreiben.pdf',url: '/assets/höhereberufsfachschule/BFS Vordruck Entschuldigungsschreiben.pdf'},
                                {label: 'BFS Lehrplan Wirtschaft',download: 'BFS Lehrplan Wirtschaft.pdf',url: '/assets/höhereberufsfachschule/BFS Lehrplan Wirtschaft.pdf'}
                            ]
                        }
                    }/>
            </div>
        </React.Fragment>

    );
}

export default Main;
